<div class="payment-card" role="listitem">
  <div class="card-header">
    <div class="header-left">
      <mat-icon class="method-icon" aria-hidden="true">payments</mat-icon>
      <span class="method-title">Cash</span>
    </div>
    <button mat-icon-button class="delete-btn" (click)="onRemove()" aria-label="Remove cash payment method">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <div class="card-body">
    <mat-form-field appearance="outline" class="field-amount">
      <mat-label>Amount</mat-label>
      <span matTextPrefix>$&nbsp;</span>
      <input
        matInput
        type="number"
        appMoney
        [value]="method.amount || ''"
        (input)="onAmountChange($any($event.target).value)"
        min="0"
        step="0.01"
        placeholder="0.00"
        aria-label="Cash payment amount"
      />
      <mat-hint>Enter a positive amount</mat-hint>
    </mat-form-field>
  </div>
</div>
